import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权
import { hasPrivilegedAdminRole, hasIntegrationModuleRole, hasCompanyModuleRole, hasSuperAdminRole, hasVerifyCardListAccess, canAccessVerifyManage, hasMemberModuleAccess, hasMemberRegisterRouteAccess, hasInnerIntegrationStatsReportAccess, hasInnerGiftBatchPageAccess, hasSupplierManagementAccess, canAccessSupplierModule, canAccessSupplierProductPages, hasPmsModuleInRoutes } from '@/utils/privilegedRoleAccess'
import { canAccessSupplierSupplyProducts, SUPPLIER_SUPPLY_ROUTE_NAMES } from '@/utils/supplierSupplyProduct'

const whiteList = ['/login', '/open-embed'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          let menus=res.data.menus;
          let username=res.data.username;
          store.dispatch('GenerateRoutes', { menus,username }).then(() => { // 生成可访问的路由表
            // 使用 addRoute 替代已废弃的 addRoutes
            const routes = store.getters.addRouters
            routes.forEach(route => {
              router.addRoute(route)
            })
            next({ ...to, replace: true })
          })
        }).catch((err) => {
          const msg = (err && err.message) ? err.message : String(err || '')
          const isForbidden = msg.indexOf('没有相关权限') !== -1 || (err && err.code === 403)
          const tip = isForbidden
            ? '无法获取当前账号信息，请让管理员在后台检查用户权限与资源分配，或更换账号后重试。'
            : (msg || '拉取用户信息失败，请重新登录')
          if (isForbidden && process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn('[GetInfo] 403: 需在后端/网关为 GET /admin/info 与当前角色正确绑定资源。')
          }
          store.dispatch('FedLogOut').then(() => {
            Message.error(tip)
            next({ path: '/login' })
          })
        })
      } else {
        if (
          to.path.startsWith('/integration/rule-consent-log') ||
          to.path.startsWith('/member/integration-rule-consent-log')
        ) {
          if (!hasSuperAdminRole(store.getters.roles)) {
            Message.warning('无权限访问会员积分协议同意日志，仅超级管理员可使用')
            next({ path: '/home' })
            NProgress.done()
            return
          }
          next()
          NProgress.done()
          return
        }
        if (to.path.startsWith('/member/integration-batch-expire')) {
          if (!hasSuperAdminRole(store.getters.roles)) {
            Message.warning('无权限访问积分批次到期记录，仅超级管理员可使用')
            next({ path: '/home' })
            NProgress.done()
            return
          }
          next()
          NProgress.done()
          return
        }
        if (to.path.startsWith('/member/sms-management')) {
          if (!hasSuperAdminRole(store.getters.roles)) {
            Message.warning('无权限访问短信管理，仅超级管理员可使用')
            next({ path: '/home' })
            NProgress.done()
            return
          }
          next()
          NProgress.done()
          return
        }
        if (to.path.startsWith('/integration/outer-gift-batch')) {
          if (!hasSuperAdminRole(store.getters.roles)) {
            Message.warning('无权限访问抵扣积分批次，仅超级管理员可使用')
            next({ path: '/home' })
            NProgress.done()
            return
          }
          next()
          NProgress.done()
          return
        }
        if (to.path.startsWith('/integration/inner-integration-display-adjustment')) {
          if (!hasSuperAdminRole(store.getters.roles)) {
            Message.warning('无权限访问冲减兑换积分配置，仅超级管理员可使用')
            next({ path: '/home' })
            NProgress.done()
            return
          }
          next()
          NProgress.done()
          return
        }
        if (to.path.startsWith('/ums/open-api-client') && !hasSuperAdminRole(store.getters.roles)) {
          Message.warning('无权限访问 Open API 客户端管理，仅超级管理员可使用')
          next({ path: '/home' })
          NProgress.done()
          return
        }
        if (to.path.startsWith('/ums/open-api-user-grant') && !hasSuperAdminRole(store.getters.roles)) {
          Message.warning('无权限访问 Open API 用户授权管理，仅超级管理员可使用')
          next({ path: '/home' })
          NProgress.done()
          return
        }
        if (to.path.startsWith('/oms/shipmentRecord') && !hasSuperAdminRole(store.getters.roles)) {
          Message.warning('无权限访问发货信息，仅超级管理员可使用')
          next({ path: '/home' })
          NProgress.done()
          return
        }
        if (to.path.startsWith('/py-script') && !hasPrivilegedAdminRole(store.getters.roles)) {
          Message.warning('无权限访问商城辅助工具，仅超级管理员、系统管理员可使用')
          next({ path: '/home' })
          NProgress.done()
          return
        }
        if (to.path.startsWith('/behavior-analysis') && !hasPrivilegedAdminRole(store.getters.roles)) {
          Message.warning('无权限访问行为统计分析，仅超级管理员、系统管理员可使用')
          next({ path: '/home' })
          NProgress.done()
          return
        }
        if (
          (to.path.startsWith('/integration') ||
            to.path.startsWith('/integration-rule') ||
            to.path.startsWith('/member/exchangeIntegrationHistory')) &&
          !hasIntegrationModuleRole(store.getters.roles)
        ) {
          Message.warning('无权限访问积分管理模块，仅积分管理员、系统管理员、超级管理员可使用')
          next({ path: '/home' })
          NProgress.done()
          return
        }
        const roles = store.getters.roles
        if (hasIntegrationModuleRole(roles) && !hasSuperAdminRole(roles)) {
          if (to.path.startsWith('/integration/rule') || to.path.startsWith('/integration-rule')) {
            Message.warning('无权限访问积分规则管理，仅超级管理员可使用')
            next({ path: '/integration/exchange-history' })
            NProgress.done()
            return
          }
          if (to.path.startsWith('/integration/inner-cash-config')) {
            Message.warning('无权限访问兑换积分折现设置，仅超级管理员可使用')
            next({ path: '/integration/exchange-history' })
            NProgress.done()
            return
          }
          if (to.path.startsWith('/integration/member-inner')) {
            Message.warning('无权限访问会员兑换积分，仅超级管理员可使用')
            next({ path: '/integration/exchange-history' })
            NProgress.done()
            return
          }
          if (to.path.startsWith('/integration/outer-gift-batch')) {
            Message.warning('无权限访问抵扣积分批次，仅超级管理员可使用')
            next({ path: '/integration/exchange-history' })
            NProgress.done()
            return
          }
          if (to.path.startsWith('/integration/inner-operation-log')) {
            Message.warning('无权限访问积分操作记录，仅超级管理员可使用')
            next({ path: '/integration/exchange-history' })
            NProgress.done()
            return
          }
          if (
            to.path.startsWith('/integration/inner-integration-stats') &&
            !hasInnerIntegrationStatsReportAccess(roles, store.getters.integrationModuleScope)
          ) {
            Message.warning('无权限访问积分统计报表，仅积分管理员、积分统计管理员或超级/系统管理员可使用')
            next({ path: '/integration/exchange-history' })
            NProgress.done()
            return
          }
          if (
            to.path.startsWith('/integration/inner-gift-batch') &&
            !hasInnerGiftBatchPageAccess(roles, store.getters.integrationModuleScope)
          ) {
            Message.warning('无权限访问兑换积分批次，需赠送积分、积分激活或积分统计报表权限')
            const fallback = hasInnerIntegrationStatsReportAccess(roles, store.getters.integrationModuleScope)
              ? '/integration/inner-integration-stats'
              : '/integration/exchange-history'
            next({ path: fallback })
            NProgress.done()
            return
          }
        }
        if (to.path.startsWith('/company') && !hasCompanyModuleRole(store.getters.roles)) {
          Message.warning('无权限访问公司管理模块，仅公司管理员、系统管理员、超级管理员可使用')
          next({ path: '/home' })
          NProgress.done()
          return
        }
        const scope = store.getters.integrationModuleScope
        if (to.path.startsWith('/verify')) {
          if (to.path.startsWith('/verify/card-list')) {
            if (!hasVerifyCardListAccess(roles, scope)) {
              Message.warning('无权限访问核销卡券列表，需赠送卡券能力或核销模块角色')
              next({ path: '/home' })
              NProgress.done()
              return
            }
          } else if (!canAccessVerifyManage(roles, scope)) {
            if (hasVerifyCardListAccess(roles, scope)) {
              next({ path: '/verify/card-list', replace: true })
              NProgress.done()
              return
            }
            Message.warning('无权限访问核销管理，仅超级管理员、系统管理员、核销管理员、卡券核销管理员可使用')
            next({ path: '/home' })
            NProgress.done()
            return
          }
        }
        if (to.path.startsWith('/member') && !hasMemberModuleAccess(roles, scope)) {
          Message.warning('无权限访问会员管理模块')
          const verifyFallback = canAccessVerifyManage(roles, scope)
            ? '/verify/manage'
            : (hasVerifyCardListAccess(roles, scope) ? '/verify/card-list' : '/home')
          next({ path: verifyFallback })
          NProgress.done()
          return
        }
        if (to.path.startsWith('/member/register') && !hasMemberRegisterRouteAccess(roles, scope)) {
          Message.warning('无权限访问注册会员，仅具备会员注册能力的管理员可使用')
          next({ path: '/member/list' })
          NProgress.done()
          return
        }
        if (to.path.startsWith('/member/job') && !hasSuperAdminRole(roles)) {
          Message.warning('无权限访问职业管理，仅超级管理员可使用')
          next({ path: '/member/list' })
          NProgress.done()
          return
        }
        if (to.path.startsWith('/supplier')) {
          if (to.name === 'pmsSupplier' && !hasSupplierManagementAccess(roles, scope)) {
            Message.warning('无权限访问供应商管理，仅超级管理员或供应商管理员可使用')
            if (canAccessSupplierProductPages(roles, scope, store.getters.routers)) {
              next({ path: '/supplier/product', replace: true })
            } else {
              next({ path: '/home' })
            }
            NProgress.done()
            return
          }
          if (
            SUPPLIER_SUPPLY_ROUTE_NAMES.indexOf(to.name) !== -1 &&
            !hasPmsModuleInRoutes(store.getters.routers) &&
            !canAccessSupplierSupplyProducts(roles, scope)
          ) {
            Message.warning('无权限访问供货商品，须供应商管理员且配置有效供应商范围')
            next({ path: '/home' })
            NProgress.done()
            return
          }
          if (
            (to.name === 'pmsRealProduct' ||
              to.name === 'pmsRealProductBackfill' ||
              to.name === 'pmsSkuRealProductRelate') &&
            !canAccessSupplierProductPages(roles, scope, store.getters.routers)
          ) {
            Message.warning('无权限访问供应商产品模块')
            next({ path: '/home' })
            NProgress.done()
            return
          }
          if (to.path.startsWith('/supplier') && !canAccessSupplierModule(roles, scope, store.getters.routers)) {
            Message.warning('无权限访问供应商模块')
            next({ path: '/home' })
            NProgress.done()
            return
          }
        }
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js